define('Components/BannerComeInWidget/js/models/BannerComeInWidgetInstanceModel',['jquery',
        'app',
        'WidgetInstanceModel',
    ],
    function ($, app, WidgetInstanceModel) {
        return WidgetInstanceModel.extend({
            name:'BannerComeInWidgetModel',
        })
    });
